import { render, staticRenderFns } from "./MaterialStandardMappingEdit.vue?vue&type=template&id=ace8ba08&scoped=true&"
import script from "./MaterialStandardMappingEdit.vue?vue&type=script&lang=js&"
export * from "./MaterialStandardMappingEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace8ba08",
  null
  
)

export default component.exports